export default __webpack_public_path__ + "static/media/prepare_for_calf.a385d949.mp3";